export function adaptDob(str: string): string {
  const [month, day] = str.split('-').map(Number);

  if (!isValidMonth(month) || !isValidDay(day)) {
    console.warn('Invalid date format');
    return '';
  }

  return `${day} ${getAbbreviatedMonthName(month)}`;
}

function getAbbreviatedMonthName(monthNumber: number): string {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return months[monthNumber - 1];
}

function isValidMonth(month: number): boolean {
  return month >= 1 && month <= 12;
}

function isValidDay(day: number): boolean {
  return day >= 1 && day <= 31;
}
